import { StubPage } from "@/components/layout/StubPage";

export default function TermsPage() {
  return (
    <StubPage
      title="Terms of Service"
      description="Terms are pending legal review. They will clarify eligibility, risk disclosures, and jurisdictional restrictions."
    >
      <p className="text-sm text-slate-600">
        This is a non-custodial protocol. By connecting your wallet you accept smart
        contract risk and agree to comply with applicable regulations.
      </p>
    </StubPage>
  );
}
